<template>
  <div>
    <div class="wrapper-spin spinner-lluvias" :class="{ 'd-none': isLoaded }" id="spinner">
      <div class="spin">
        <img src="/images/icons/spin.png" alt="Spinner">
      </div>
    </div>
    <div class="row justify-content-center pt-4 pt-lg-5 pb-3 mt-4 mb-4">
      <!--mensaje-->
      <div class="col-md-9 col-xl-7" v-if="!rainfalls || !color_ranges">
        <div class="w-100 shadow p-3">
          <div class="card rounded-0 border border-primary bg-lightPrimary2 py-5 py-lg-5 m-0">
            <div class="card-body d-flex flex-column align-items-center justify-content-center py-5">
              <h4 class="h4-sm font-ARB text-primary text-center mb-3 mb-lg-4">La consulta no está disponible en estos
                momentos.</h4>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <!--mensaje-->
        <div class="col-md-12 pb-3">
          <div class="row justify-content-center">
            <div class="col-lg-12 col-xl-12 mb-4">
              <div class="row justify-content-center">
                <div class="col-sm-7 col-lg-8 col-xl-5">
                  <p class="font-AR text-gray text-center mb-4">Visualizá las precipitaciones ocurridas, a través de
                    registros pluviométricos que ingresan usuarios de Boosteagro en los últimos 7 días.</p>
                </div>
              </div>
            </div>
            <div class="wrapper-ref col-12 col-xl max-w-870 mb-0 mb-xl-0 mt-auto">
              <div class="row justify-content-center">
                <div class="col-md-12 col-lg-7 col-xl-12">
                  <div class="row g-0 align-items-end ">
                    <div class="w-100 d-flex flex-wrap border border-borders shadow p-1">
                      <div v-for="(color, index) in color_ranges"
                        class="wrapper-content col-4 col-xl d-flex flex-column justify-content-center align-items-center p-2"
                        :style="{ 'background-color': color.color }">
                        <h5 class="text-white font-PB text-nowrap mb-0">{{ color.label }}</h5>
                        <p class="font-Pm text-white mt-n2 mb-0">mm</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12 wrapper-mapalluvias">
          <div class="w-100 shadow-lg border border-borders p-2">
            <link href='https://api.mapbox.com/mapbox-gl-js/v2.2.0/mapbox-gl.css' rel='stylesheet' />
            <div id="map" class="bg-borders"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

const API_KEY = 'pk.eyJ1IjoiZGV2dGVhbWFyZ2VudGluYSIsImEiOiJjbGdjZTl5ZTAwNmMyM3NteG5kbW01YzJmIn0.ru7RkO04bEzoGRmekPWExw';

import mapboxgl from 'mapbox-gl'
import "mapbox-gl/dist/mapbox-gl.css"


export default {

  name: 'rainfall',
  props: ['rainfalls', 'color_ranges'],
  data() {
    return {
      map: null,
      ready: false,
      showWeatherModal: false,
      openPopField: false,
      modalDescription: '',
      isLoaded: false,
      mapGenerated: false,
      unwatchMapChanges: null
    }
  },
  components: { mapboxgl },
  mounted() {
  this.unwatchMapChanges = this.$watch(
    () => [this.rainfalls, this.color_ranges],
    ([newRainfalls, newColorRanges]) => {
      if (
        !this.mapGenerated &&
        newRainfalls &&
        newColorRanges &&
        newColorRanges.length > 0
      ) {
        this.generateMap();
        this.mapGenerated = true;

        // Pequeño delay antes del unwatch()
        setTimeout(() => {
          this.unwatchMapChanges();
        }, 0);
      }
    },
    { immediate: true }
  );
},
  methods: {
    hideBoxRains() {
      this.$emit('hide-box-rains');
    },

    generateMap() {
      this.isLoaded = true;
      let data = this.rainfalls;
      let vm = this;
      mapboxgl.accessToken = API_KEY;
      this.map = new mapboxgl.Map({
        container: 'map',
        style: 'mapbox://styles/mapbox/satellite-streets-v9',
        center: [-58.416097, -38.616672],
        zoom: 3,
        showZoom: false,
        attributionControl: false
      });


      this.map.on('load', function () {
        // Add a geojson point source.
        // Heatmap layers also work with a vector tile source.

        $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
          vm.map.resize();
        });

        vm.map.addSource('trees', {
          "type": "geojson",
          "data": data
        });

        //Circles
        vm.map.addLayer({
          "id": "trees-point",
          "type": "circle",
          "source": "trees",
          "minzoom": 1,
          "maxzoom": 11,
          "paint": {

            "circle-radius": {
              property: 'dbh',
              stops: [
                [{ zoom: 1, value: 1 }, 5],
                [{ zoom: 1, value: 60 }, 10],
                [{ zoom: 11, value: 1 }, 20],
                [{ zoom: 11, value: 60 }, 50]
              ],
              base: 2
            },

            'circle-color': ['get', 'color'], // get() => features[i].properties.color

            "circle-stroke-color": "white",
            "circle-stroke-width": 0,
            // Transition from heatmap to circle layer by zoom level
            "circle-opacity": [
              "interpolate",
              ["linear"],
              ["zoom"],
              2, 1.2,
              14, 0.6
            ],
            "circle-blur": [
              "interpolate",
              ["linear"],
              ["zoom"],
              3, 1.2,
              5, 1.5,
              7, 0
              // El zoom nivel 1 es el mas lejos y el 10 aprox el mas cercano
            ]

          }
        }, 'waterway-label');
      });
    },
  }
}

</script>
<style lang="scss">
#map {
  width: 100%;
  height: 86.2vh;
}
</style>